require('sass/brands/locations.firstinterstatebank.com/search/default.scss');
require('js/search-script.js');
